import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Navigation Menu',
  basePath: '/nav-menu',
  reorderable: true,
  columns: [
    { key: 'title', label: 'Title' },
    { key: 'link', label: 'Link' },
    { key: 'parent_title', label: 'Parent' },
    { key: 'mega_menu', label: 'Mega Menu',
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'show', label: 'Show',
      render: (v) => v == 1 ? 'Yes' : 'No' },
    { key: 'sitemap_priority', label: 'Sitemap Priority' },
  ],
  fields: [
    { key: 'title', label: 'Title', type: 'text', required: true },
    { key: 'link', label: 'Link', type: 'text' },
    { key: 'parent_id', label: 'Parent', type: 'async-select',
      optionsUrl: '/nav-menu/options', defaultValue: '0' },
    { key: 'mega_menu', label: 'Mega menu', type: 'yesno' },
    { key: 'show', label: 'Show', type: 'yesno', defaultValue: '1' },
    { key: 'sitemap_priority', label: 'Sitemap priority', type: 'text' },
  ],
});
